import { connect, ConnectedProps } from 'react-redux';
import { createSelector } from 'reselect';
import { StateType } from '../../../../state/reducers';
import { Folder } from '../../../folders.types';

const foldersSelector = (state: StateType) => state.folders.folders;
const latestUpdatedFoldersSelector = (state: StateType) =>
  state.latestUpdated.folders;

const getFolders = createSelector(
  foldersSelector,
  latestUpdatedFoldersSelector,
  (folders, order) => order.map((folderKey) => folders[folderKey]),
);

const mapState = (state: StateType) => {
  const folders: Array<Folder> = getFolders(state);

  return {
    folders,
    key: `${folders.length}`,
  };
};

export const Connect = connect(mapState);

export type PropsFromRedux = ConnectedProps<typeof Connect>;
